export default () => 'show';
